const secondary = {
    social_bind_with: 'Masz już konto? Zaloguj się, aby połączyć {{methods, list(type: disjunction;)}} z twoją tożsamością społeczną.',
};
export default Object.freeze(secondary);
